import { accountPageDevicesModel } from 'pages/account-page/model';
import { createDeleteDeviceDetailedModal } from 'features/delete-device';
import { createEditDeviceDetailedModal } from 'features/edit-device';
import { createDeviceRegistry } from 'entities/device';
import cls from './account-page-devices.module.scss';

const DeleteDeviceModal = createDeleteDeviceDetailedModal(
	accountPageDevicesModel.deleteDeviceModel,
);

const EditDeviceModal = createEditDeviceDetailedModal(accountPageDevicesModel.editDeviceModel);

const DevicesRegistry = createDeviceRegistry(accountPageDevicesModel.deviceRegistryModel);

export const AccountPageDevices = () => (
	<>
		<DevicesRegistry
			withTitle={false}
			withAccount={false}
			className={cls.accountPageDevicesRegistry}
			tableTdActionSlot={(device) => (
				<div className={cls.accountPageDevicesActions}>
					<EditDeviceModal.ActionIcon modalData={device} />
					<DeleteDeviceModal.ActionIcon modalData={device} />
				</div>
			)}
		/>
		<EditDeviceModal />
		<DeleteDeviceModal />
	</>
);
